__webpack_require__.p = "/ranchsatdb/";